/**
 * Sidebar delete-confirmation dialog. Extracted verbatim (behavior-preserving)
 * from the two structurally identical "Delete chat?" / "Delete module?" confirm
 * overlays in layout/Sidebar.tsx. The orchestrator still gates rendering on the
 * delete-target state (`{deleteConversationTarget && <DeleteConfirmDialog … />}`)
 * so mount/unmount semantics are unchanged; only the title, target name,
 * pending flag, and the close/confirm handlers vary between the two call sites.
 */

interface DeleteConfirmDialogProps {
  title: string;
  targetName: string;
  isPending: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function DeleteConfirmDialog({
  title,
  targetName,
  isPending,
  onClose,
  onConfirm,
}: DeleteConfirmDialogProps) {
  return (
    <div className="conversation-delete-confirm-overlay" onClick={onClose}>
      <div className="conversation-delete-confirm-modal" onClick={(event) => event.stopPropagation()}>
        <h3 className="conversation-delete-confirm-title">{title}</h3>
        <p className="conversation-delete-confirm-message">
          Permanently delete <strong>{targetName}</strong>? This action cannot be undone.
        </p>
        <div className="conversation-delete-confirm-actions">
          <button
            className="conversation-delete-confirm-btn conversation-delete-confirm-btn-cancel"
            onClick={onClose}
            disabled={isPending}
          >
            Cancel
          </button>
          <button
            className="conversation-delete-confirm-btn conversation-delete-confirm-btn-danger"
            onClick={onConfirm}
            disabled={isPending}
          >
            {isPending ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
}
